/*
* (C) Behaviour Interactive Inc. - All Rights Reserved
* Unauthorized copying of this file, via any medium, is strictly prohibited
* This file is proprietary and confidential
*/

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Reward } from './Promotion.model';

import rewardImgPlaceholder from '../../_assets/bhvr-footer.png';

interface Props {
  reward: Reward
}

export function PromotionReward({ reward } : Props): JSX.Element {
  const { t } = useTranslation(['promotions']);

  return (
    <div className='container reward'>
      {reward?.gameSpecificData?.rarity && (
        <section className='row rarity-wrap'>
          <div className='col rarity-container'>
            <span className='rarity-content'>{t(`promotions:${reward.gameSpecificData.rarity}`)}</span>
          </div>
        </section>
      )}
      <section className='row img-wrap'>
        <div className='col img-container'>
          <img
            className='img-content'
            src={process.env.NODE_ENV === 'development' ? rewardImgPlaceholder : reward.pictureURL}
            alt={t(`promotions:${reward.displayName}`)}
          />
        </div>
      </section>
      <section className='row description-wrap'>
        <div className='col description-container'>
          {reward?.gameSpecificData?.universalStatus && (
            <span className='description-universal-status'>
              {t(`promotions:${reward.gameSpecificData.universalStatus}`)}
            </span>
          )}
          <h3 className='description-display-name'>{t(`promotions:${reward.displayName}`)}</h3>
        </div>
      </section>
    </div>
  );
}
